/** Coach shows only when AI is on, and stays on until a client explicitly turns it off. */
export function isMiaCoachEnabled(
  aiPowered: boolean | undefined,
  miaCoachEnabled: boolean | undefined
): boolean {
  return aiPowered === true && miaCoachEnabled !== false;
}
